import isNull from "../../../utils/NullChecking";
const DropdownValueHandler = (DropDown, Value) => {
    if (!isNull(Value) && DropDown?.length > 0) {
        const selectedType = DropDown.find(type => (type.value + "" === Value + ""));
        if (selectedType) {
            return selectedType.display;
        }
    }
    return null; // Return a default value if no match is found
};

export default DropdownValueHandler;